<template>
  <v-dialog v-model="dialog" hide-overlay transition="dialog-bottom-transition" max-width="800px">
    <v-card>
      <v-card-title class="text-subtitle-1">
        Danh sách nhân viên
        <v-spacer></v-spacer>
        <v-icon color="white" @click="dialog = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              dense
              style="max-width: 200px"
              label="Tìm kiếm"
              v-model="search"
            ></v-text-field>
            <v-data-table
              :loading="loading"
              :search="search"
              :items="employees"
              :headers="headers"
              dense
              single-select
              item-key="code"
              v-model="selected"
              show-select
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="customBtn"></slot>
        <v-btn depressed dark color="teal darken-4" @click="select">
          <v-icon small left>mdi-check-circle</v-icon>
          Chọn
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import http from '@/components/services/http-common';

export default {
  name: "EmployeeDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      loading: false,
      selected: [],
      search: "",
      employees: [],
      headers: [
        { text: 'Mã nhân viên', value: 'code' },
        {
          text: 'Tên nhân viên',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Giới tính', value: 'gender' },
        { text: 'Phòng', value: 'departmentName' }
      ]
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await http.get('employees/simple');
        this.employees = res.data;
      } catch (err) {
        console.error('Error fetching employees:', err);
      } finally {
        this.loading = false;
      }
    },
    select() {
      this.$emit("select", this.selected);
      this.selected = [];
      this.dialog = false;
    }
  },
  created() {
    this.fetchData();
  }
};
</script>